(() => {
  const selector = '[data-payment-message]';

  const setup = root => {
    if (root.dataset.paymentMessageReady === 'true') return;

    const viewport = root.querySelector('[data-payment-message-viewport]');
    const track = root.querySelector('[data-payment-message-track]');
    const text = root.querySelector('[data-payment-message-text]');
    if (!viewport || !track || !text) return;

    root.dataset.paymentMessageReady = 'true';

    const update = () => {
      track.querySelectorAll('.yamuri-payment-message__text-clone').forEach(node => node.remove());
      root.classList.remove('is-overflowing');

      const clone = text.cloneNode(true);
      clone.removeAttribute('data-payment-message-text');
      clone.classList.add('yamuri-payment-message__text-clone');
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
      root.classList.add('is-overflowing');
    };

    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(update);
      observer.observe(viewport);
    } else {
      window.addEventListener('resize', update, { passive: true });
    }

    text.querySelectorAll('img').forEach(image => {
      if (!image.complete) image.addEventListener('load', update, { once: true });
    });

    requestAnimationFrame(update);
  };

  const init = scope => scope.querySelectorAll(selector).forEach(setup);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', event => init(event.target));
})();
